import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useArpMedia } from '../../../__legacy__/queries/arpMedia'
import { useUser } from '../../../__legacy__/queries/users'
import { detailPagePath } from '../../arp-media-utils'
import { profilePath } from '../../profile'
import { Notification } from '../primatives'
import { MintCompletedNotificationType } from '../types'
import { notificationTimeAgo } from '../utils'

interface Props {
  notification: MintCompletedNotificationType
}

export const ActivityMintedNotification: FC<Props> = ({ notification }) => {
  const userQuery = useUser({ walletAddressOrId: notification.notifiableId })
  const arpMediaQuery = useArpMedia({ id: notification.data.arpId })

  if (userQuery.isLoading || arpMediaQuery.isLoading) {
    return null
  }

  return (
    <Notification.Root>
      <Notification.Avatar src={userQuery.data.profilePicture?.url} />
      <Notification.Title>
        <Link to={profilePath(userQuery.data)}>
          <Notification.Link>{userQuery.data.displayName}</Notification.Link>
        </Link>
        {`minted `}
        <Link to={detailPagePath(arpMediaQuery.data)}>
          <Notification.Link css={{ marginLeft: '4px' }}>
            {arpMediaQuery.data.metadata.title}
          </Notification.Link>
        </Link>
      </Notification.Title>
      <Notification.Stats>{notificationTimeAgo(arpMediaQuery.data.createdAt)}</Notification.Stats>
    </Notification.Root>
  )
}
